import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '@/environments/environment';
import { SafePipe } from '@/app/shared/pipes/safe.pipe';

@Component({
  standalone: true,
  selector: 'app-api-layout',
  imports: [CommonModule, SafePipe],
  template: `
    <div class="w-screen h-screen">
      <iframe
        [src]="iframeUrl | safe: 'resourceUrl'"
        width="100%"
        height="100%"></iframe>
    </div>
  `,
})
export class ApiLayoutComponent {
  iframeUrl = `${environment.docsUrl}/docs/api/intro`;
}
